"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function formatDuration(duration) {
  if (!duration) {
    return "";
  }
  var mins = Math.floor(duration / 60);
  if (mins < 10) {
    mins = "0".concat(String(mins));
  }
  var secs = Math.floor(duration % 60);
  if (secs < 10) {
    secs = "0".concat(String(secs));
  }
  return "".concat(mins, ":").concat(secs);
}
var PlaylistItem = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var name = _ref.name,
    metadata = _ref.metadata,
    duration = _ref.duration,
    selected = _ref.selected,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
    css: {
      flexDirection: "column",
      alignItems: "flex-start",
      h: "$18",
      p: "$8",
      "&:hover": {
        cursor: "pointer",
        bg: "$menuBg"
      },
      "&:focus-visible": {
        bg: "$menuBg"
      }
    },
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      justify: "between",
      css: {
        width: "100%",
        minHeight: 0
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "md",
        css: {
          color: selected ? "$brandDefault" : "$textPrimary"
        },
        children: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "xs",
        children: formatDuration(duration)
      })]
    }), (metadata === null || metadata === void 0 ? void 0 : metadata.description) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "xs",
      css: {
        mt: "$4"
      },
      children: metadata === null || metadata === void 0 ? void 0 : metadata.description
    })]
  });
});
exports.PlaylistItem = PlaylistItem;